module.exports = __webpack_public_path__ + "img/nada-consta.adfe1b51.jpg";